export function evaluationWayListAll() {
  return '{evaluationWayListAll{id, name, active}}';
}

export function evaluationWayListByFilter(filter) {
  return `{ 
    evaluationWayListByFilter(filter: ${JSON.stringify(filter).replace(
      /"([^(")"]+)":/g,
      '$1:'
    )}) {
      id,
      name
      value
      label
      active
      description
    }
  }`;
}

export function evaluationWaySave(values) {
  return `mutation {
    evaluationWaySave(                              
      evaluationWay: {id: ${values.id ? values.id : 0}
                    , name: "${
                      values.name
                    }"                                            
                    , description: "${
                      values.description ? values.description : ''
                    }"
                    , active: ${values.active}
                    , filterByStatus: false                                        
                    , updaterId: 0
                }),
    {id}
}`;
}

export function query() {
  return '{evaluationWayListAll{id, name, active}}';
}

export function mutation(value) {
  return `mutation {evaluationWayRemove(id: ${value.id})}`;
}
